import React, { useEffect } from "react";
import MyRouter from "routers/index";
import { useTranslation } from "react-i18next";
import { useClient } from "ClientContext";
import { useRewardfull } from "hooks/useRewardfull";

function App() {
  const { global_language } = useClient();
  const { i18n } = useTranslation();
  const { changeLanguage } = i18n;
  
  useRewardfull();

  useEffect(() => {
    if (global_language && i18n.language !== global_language) {
      changeLanguage(global_language); // Update language only if it has changed
    }
  }, [changeLanguage, global_language, i18n.language]);

  return (
    <div className="bg-white text-base dark:bg-neutral-900 text-neutral-900 dark:text-neutral-200">
      <MyRouter />
    </div>
  );
}

export default App;